export var ToastType;
(function (ToastType) {
    ToastType["Regular"] = "regular";
    ToastType["Success"] = "success";
    ToastType["Error"] = "error";
    ToastType["Loading"] = "loading";
    ToastType["Progress"] = "progress";
})(ToastType || (ToastType = {}));
